<nav class="custom-header d-flex align-items-center justify-content-between px-4">
  <div class="d-flex align-items-center gap-3">
    <button class="btn btn-icon sidebar-toggle d-lg-none" (click)="onToggleClick()">
      <i class="fa-solid fa-bars"></i>
    </button>
    <!-- Component Title based on route -->
    <h4 class="mb-0 fw-bold header-title d-flex align-items-center gap-2">
      <i class="bi bi-layout-sidebar header-icon"></i>
      {{ pageTitle || 'Dashboard' }}
    </h4>
  </div>

  <div class="header-actions d-flex align-items-center gap-4">
    <!-- Theme Toggle -->
    <button class="btn btn-icon theme-toggle" (click)="toggleTheme()">
      <i [ngClass]="(themeService.isDarkMode$ | async) ? 'bi bi-sun-fill text-warning' : 'bi bi-moon-stars'"></i>
    </button>

    <!-- User Profile Dropdown -->
    <div class="dropdown" *ngIf="currentUser$ | async as user">
      <button class="btn profile-dropdown-btn d-flex align-items-center gap-2" type="button" id="profileDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="profile-avatar">
          <img *ngIf="user.profileImageUrl" [src]="user.profileImageUrl" alt="Profile">
          <span *ngIf="!user.profileImageUrl">{{ (user.firstName.charAt(0) || 'U') | uppercase }}</span>
        </div>
        <span class="profile-name fw-semibold d-none d-md-block">{{ user.firstName }}</span>
        <i class="bi bi-chevron-down ms-1 text-muted small"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2" aria-labelledby="profileDropdown">
        <li>
          <a class="dropdown-item d-flex align-items-center gap-2" routerLink="/user/accounts">
            <i class="bi bi-person"></i> Profile
          </a>
        </li>
        <li>
          <a class="dropdown-item d-flex align-items-center gap-2" (click)="goHome()" style="cursor: pointer;">
            <i class="bi bi-house"></i> Go to Home
          </a>
        </li>
        <li><hr class="dropdown-divider"></li>
        <li>
          <a class="dropdown-item text-danger d-flex align-items-center gap-2" (click)="logout()" style="cursor: pointer;">
            <i class="bi bi-box-arrow-right"></i> Logout
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
